// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"a2101ac9","182":"f2758384","268":"f2283822","484":"ad1efcee","551":"ebbd964c","828":"eb847711"}[chunkId] + ".chunk.js";
};